<yat-web-checkout-header
  [pictureSource]="(productLocalization$ | async)?.productPicturePath"
  [title]="(productLocalization$ | async)?.productName"
  [subtitle]="'commercialCommon.commercialHeader.byVendor' | transloco: { vendorName: vendorName$ | async }"
  *yatVar="enableShoppingCartConfigurator$ | async as enableShoppingCartConfigurator">
  <div
    (tabSelect)="showMobileDialog()"
    yatTabSelectable
    *yatVar="productCategory$ | async as productCategory"
    class="license-type text-sm relative flex flex-col items-start justify-start bg-white mt-4 -mb-12 border-solid border-[0.5px] border-n-30 shadow-panel skeleton-item pt-3 pb-3"
    [class.cursor-pointer]="enableShoppingCartConfigurator">
    <span *ngIf="productVariant$ | async as productVariant" class="flex"> {{ productVariant }}</span>
    <span *ngIf="groupName$ | async as groupName" class="flex gap-1">
      <yat-icon name="user-group-duo" style="--icon-width: 16px; --icon-height: 16px" class="flex flex-col justify-start"></yat-icon>
      {{ 'commercialCommon.commercialHeader.group' | transloco: { groupName: groupName } }}
    </span>
    <span *ngIf="selectedQuantity$ | async as selectedQuantity" [hidden]="selectedQuantity <= 1" class="flex gap-1">
      <yat-icon name="add-product-duo" style="--icon-width: 16px; --icon-height: 16px" class="flex flex-col justify-start"></yat-icon>
      {{ 'commercialCommon.commercialHeader.quantity' | transloco: { quantity: selectedQuantity } }}
    </span>

    <yat-commercial-header-travel-ticket-description *ngIf="productCategory === 'TRAVEL_TICKET'"> </yat-commercial-header-travel-ticket-description>
    <span *ngIf="productCategory === 'SOFTWARE' || productCategory === 'PAID_CONTENT'" class="flex gap-1">
      <yat-icon
        id="12284cc5-c8dd-4918-8056-8aea9a077a9b"
        name="user-circle-duo"
        style="--icon-width: 16px; --icon-height: 16px"
        class="flex flex-col justify-start"></yat-icon>
      {{ 'commercialCommon.commercialHeader.singleUserLicense' | transloco }}
    </span>

    <div *ngIf="licenseKind$ | async as licenseKind" class="flex flex-col flex-grow flex-wrap overflow-hidden items-start">
      <span *yatVar="getLimitedTermDuration((licenseValidity$ | async)?.duration ?? null) as licenseValidityDuration">
        <span *ngIf="licenseValidityDuration" class="flex gap-1">
          <yat-icon
            id="21340343-e93f-4c48-a0fb-dbee7086f882"
            name="history"
            style="--icon-width: 16px; --icon-height: 16px"
            class="flex flex-col justify-start"></yat-icon>
          {{ licenseValidityDuration | limitedTerm | async }}
        </span>
      </span>

      <ng-container *ngIf="productCategory">
        <ng-container *yatVar="licenseValidity$ | async as licenseValidity">
          <span *ngIf="licenseValidity" class="flex gap-1"
            ><yat-icon
              id="2ad1c4a8-a0ba-4d26-87aa-a6367623455c"
              name="calendar-duo"
              style="--icon-width: 16px; --icon-height: 16px"
              class="flex flex-col justify-start"></yat-icon>
            <yat-license-validity
              id="3cc9550d-447b-4ca8-a08e-1f768d07fc32"
              class="text-left"
              [isLicenseValidityEditable]="enableShoppingCartConfigurator ?? false"
              [licenseValidity]="licenseValidity ?? undefined"
              [productCategory]="productCategory"
              [licenseKindType]="licenseKind.type"></yat-license-validity
          ></span>
        </ng-container>
      </ng-container>
      <span
        *ngIf="licenseKind.type === 'SUBSCRIPTION'"
        class="tooltip-tag flex gap-1"
        [yatTooltip]="'commercialCommon.commercialHeader.subscriptionTooltip' | transloco">
        <yat-icon
          id="b0c7ceb6-9763-4c44-85f6-c6b1965b970f"
          name="subscription-duo"
          style="--icon-width: 16px; --icon-height: 16px"
          class="flex flex-col justify-start"></yat-icon>
        {{ licenseKind.subscriptionInterval | subscriptionInterval: 'subscription' | async }}
      </span>
    </div>

    <ng-container *ngIf="maxNumberOfPersons$ | async as maxNumberOfPersons">
      <span *ngIf="maxNumberOfPersons > 1" class="flex gap-1">
        <yat-icon id="64dc3848-17c2-4514-ae7a-2c079a4cd67a" name="person" class="flex flex-col justify-start"></yat-icon
        >{{ 'commercialCommon.commercialHeader.upToMaxPersons' | transloco: { numberOfPersons: maxNumberOfPersons } }}
      </span>
    </ng-container>
    <div *yatVar="endOfPeriod$ | async as endOfPeriod">
      <ng-container *ngIf="assetOwnershipStatus$ | async as assetOwnershipStatus">
        <yat-status-tag
          *ngIf="assetOwnershipStatus && (showStatusTag$ | async)"
          [configurations]="
            endOfPeriod
              ? OWNERSHIP_STATUS_TAG_CONFIGURATIONS(endOfPeriod | translocoDate, 'tooltip-one-line')
              : OWNERSHIP_STATUS_TAG_CONFIGURATIONS(undefined, 'tooltip-one-line')
          "
          [leftMargin]="false"
          [transparent]="true"
          [status]="assetOwnershipStatus"
          class="header-status-tag">
        </yat-status-tag>
      </ng-container>
    </div>
    <div class="extended-header absolute" *ngIf="enableShoppingCartConfigurator">
      <yat-icon id="1df06ab1-b00d-4bb1-b163-a3deccbeb9c3" class="chevron-icon" *ngIf="isMobile(); else cog" name="chevron-right"> </yat-icon>
      <ng-template #cog>
        <yat-icon id="5a51eb63-0323-4992-b1bf-a6da4b3ce551" class="cog-icon" *ngIf="!isMobile()" name="cog-duo"></yat-icon>
      </ng-template>
    </div>
  </div>

  <ng-template #desktopDrawerContent *ngIf="!isMobile() && enableShoppingCartConfigurator">
    <yat-shopping-cart-configurator id="00db3108-8386-48f1-9bd8-cdccd3c91263" (closeEvent)="closeDialog()"> </yat-shopping-cart-configurator>
  </ng-template>

  <yat-mobile-draw-dialog
    [id]="id + 'cd54ece5-ff83-30de-81bb-aa5ef6fff21b'"
    [showDialog]="showDialogExtendedHeader && isMobile() && (enableShoppingCartConfigurator ?? false)"
    (abortConfirmModal)="closeMobileDialog()">
    <ng-container ngProjectAs="primaryMenu"
      ><yat-shopping-cart-configurator id="f33966f6-9439-4406-aa42-b25013fbad04" (closeEvent)="closeMobileDialog()"> </yat-shopping-cart-configurator
    ></ng-container>
  </yat-mobile-draw-dialog>
</yat-web-checkout-header>
